const Colors = {
    Black: '#081717',
    White: '#FFFFFF',
    // NEON
    Neon: {
        Black: '#0F2424',
        Shade: '#277047',
        Primary: '#06F994',
        Light1: '#73DEA1',
        Light2: '#C5F0D7',
        Light3: '#F0F5F0'
    },
    // TRUST
    Trust: {
        Black: '#05153D',
        Shade: '#0B3078',
        Primary: '#0080FF',
        Light1: '#557CC9',
        Light2: '#7798D9',
        Light3: '#C4D7FD'
    },
    // FOREST
    Forest: {
        Primary: '#183F3F',
        Light1: '#3E5C5C',
        Light2: '#799494',
        Light3: '#BAD6D6'
    },
    // NEUTRAL
    Neutral: {
        Shade: '#B5B5B5',
        Primary: '#E8E8E8',
        Light1: '#F6F6F6',
        Light2: '#FAFAFA',
    },
    // CORAL
    Coral: {
        Primary: '#F5674E',
        Light: '#FFCDC5'
    },
    Purple: {
        Primary: '#AA6DE7'
    }
}

export default Colors